module.exports = __webpack_public_path__ + "img/0.fd1effa6.png";